export default __webpack_public_path__ + "static/media/uploader-abbottXtra-4.b1f6060c.png";